import api from "./api.js";

export default class RetiredApi {
  static async createRetired(data) {
    return await api.post(`api/retired-member`, data);
  }
}
